import React, { Component } from "react";
import { string, func } from "prop-types";
import { connect } from "react-redux";
import Button from "../button/Button.js";
import UploadButton from "../button/UploadButton.js";
import Input from "../input/Input.js";
import Row from "../grid/Row.js";
import Col from "../grid/Col";
import Checkbox from "../checkbox/Checkbox.js";
import { clearErrorsForInput, setErrors } from "../../actions/error.js";
import {
	createAttachment,
	updateAttachment,
	deleteAttachments
} from "../../actions/attachment.js";
import FaPlus from "react-icons/lib/fa/plus";
import "./AttachmentUploader.css";

/**
 * ATTACHMENT TYPES
 * 1 - Description attachment
 * 2 - Proposal Attachment
 * 3 - Budget Attachment
 * 4 - Document Attachment
 * 5 - Concept note attachment
 * 6 - Contract attachment
 * 7 - Photos attachment
 * 8 - Purchases attachment
 */

class AttachmentUploader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showForm: false,
			showConfirm: false,
			confirmed: false,
			isUpdate: false, // current form is for updating or not
			is_confidential: false,
			attachment_id: null,
			attachment_name: "",
			attachment_url: "",
			file: null,
			data: null,
			delete: null,
			filename: ""
		};

		this.renderAttachments = this.renderAttachments.bind(this);
		this.openForm = this.openForm.bind(this);
		this.renderForm = this.renderForm.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.onAddClick = this.onAddClick.bind(this);
		this.handleFileInput = this.handleFileInput.bind(this);
		this.resetState = this.resetState.bind(this);
		this.onBadgeClick = this.onBadgeClick.bind(this);
		this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
		this.onUpdateClick = this.onUpdateClick.bind(this);
	}

	static PropTypes = {
		name: string,
		typeId: string,
		onChange: func,
		value: string,
		ph: string
	};

	/**
	 * Change handler for inputs
	 * @param {string} text
	 * @param {string} name
	 */
	handleInputChange(text, name) {
		this.setState({ [name]: text });
	}

	/**
	 * Change handler for file input
	 * @param {object} e
	 */
	handleFileInput(e) {
		e.preventDefault();

		let reader = new FileReader();
		let file = e.target.files[0];

		reader.onloadend = () => {
			this.setState({
				filename: file.name,
				file: file,
				data: reader.result
			});
		};

		reader.readAsDataURL(file);
	}

	/**
	 * Change handler for checkbox
	 * @param {any} value
	 * @param {string} name
	 */
	handleCheckboxChange(value, name) {
		this.setState({ [name]: !value });
	}

	openForm() {
		this.setState({ showForm: true });
	}

	onAddClick() {
		// ADD ATTACHMENT & UPLOAD FILE
		if (this.validateCreate()) {
			const attachment = {
				type: this.props.typeId,
				file_name: this.state.attachment_name,
				is_confidential: this.state.is_confidential,
				file: this.state.file
			};

			this.props.createAttachment(attachment);
			this.resetState();
		}
	}

	onBadgeClick(attachment) {
		this.setState({
			showForm: true,
			isUpdate: true,
			attachment_id: attachment.id,
			attachment_name: attachment.file_name,
			attachment_url: attachment.url,
			is_confidential: attachment.is_confidential
		});
	}

	onUpdateClick() {
		if (this.validateUpdate()) {
			const attachment = {
				id: this.state.attachment_id,
				file_name: this.state.attachment_name,
				is_confidential: this.state.is_confidential,
				file: this.state.file
			};
			console.log(attachment);
			this.props.updateAttachment(attachment);
			this.setState({
				showConfirm: false,
				confirmed: false,
				isUpdate: false,
				showForm: false,
				error: false
			});
		}
	}

	onDeleteClick(id) {
		this.setState({
			showConfirm: true,
			confirmed: false,
			delete: id
		});
	}

	onDeleteConfirm() {
		this.props.deleteAttachments([this.state.delete]);
		this.setState({
			showConfirm: false,
			showForm: false,
			confirmed: true,
			delete: null
		});
	}

	resetState() {
		this.setState({
			showConfirm: false,
			confirmed: false,
			isUpdate: false,
			showForm: false,
			attachment_name: "",
			file: null,
			data: null,
			filename: ""
		});
	}

	validateCreate() {
		let errors = {};
		if (!this.state.attachment_name) {
			errors["attachment_name"] = ["Attachment Name is required!"];
		}

		if (!this.state.data) {
			errors["attachment_file"] = ["File is required!"];
		}

		this.props.addErrors(errors);
		return Object.keys(errors).length === 0;
	}

	validateUpdate() {
		let errors = {};
		if (!this.state.attachment_name) {
			errors["attachment_name"] = ["Attachment Name is required!"];
		}

		this.props.addErrors(errors);
		return Object.keys(errors).length === 0;
	}

	renderAttachmentBadge(attachment, index) {
		const render =
			(attachment.is_confidential && this.props.currentUser.is_admin) ||
			!attachment.is_confidential;

		if (render) {
			return (
				<div
					className="attachment-badge"
					key={index}
					onClick={this.onBadgeClick.bind(this, attachment)}
				>
					{attachment.file_name}
					<Button
						className="btn-plain"
						onClick={this.onDeleteClick.bind(this, attachment.id)}
					>
						X
					</Button>
				</div>
			);
		} else {
			return null;
		}
	}

	renderAttachments() {
		const attachments = this.props.attachments.filter(
			a => a.type === this.props.typeId
		);

		if (attachments.length > 0) {
			return (
				<div className="attachments">
					{attachments.map((a, i) => this.renderAttachmentBadge(a, i))}
				</div>
			);
		}
	}

	renderForm() {
		const {
			filename,
			attachment_name,
			attachment_url,
			is_confidential,
			isUpdate
		} = this.state;

		return (
			<Col _bottom-24 new-attachment>
				<h2 className="filename">{filename || "No File Selected"}</h2>
				<div>
					<label htmlFor="attachment_name" className="key">
						attachment name:
					</label>
					<Row _no-grow _gap-16 bottom-16 _no-align upload-name>
						<Input
							ph="Name"
							name="attachment_name"
							value={attachment_name}
							onChange={this.handleInputChange}
						/>
						<UploadButton
							className="btn-blue btn-square add-file-btn"
							onChange={this.handleFileInput}
							accept="*"
							name="attachment_file"
						>
							{filename.length ? "Change File" : "Add File"}
						</UploadButton>
					</Row>
					<Row _gap-16 _no-align>
						<Checkbox
							name="is_confidential"
							value={is_confidential}
							onCheckboxClick={this.handleCheckboxChange}
							text="Confidential"
							checked={is_confidential}
						/>
					</Row>
				</div>
				<Row _gap-16 _no-grow>
					<Button className="btn-plain btn-red-text" onClick={this.resetState}>
						cancel
					</Button>
					{attachment_url && (
						<a className="btn-blue download-btn" href={attachment_url}>
							Download Existing
						</a>
					)}
					<Button
						className="btn-green-text btn-plain"
						onClick={!isUpdate ? this.onAddClick : this.onUpdateClick}
					>
						Save
					</Button>
				</Row>
			</Col>
		);
	}

	renderConfirm() {
		return (
			<div className="delete-confirmation">
				The attachment will be deleted permanently! Are you sure you want to
				proceed?
				<div className="buttons">
					<Button
						className="btn-green btn-stretch"
						onClick={this.onDeleteConfirm}
					>
						Yes
					</Button>

					<Button
						className="btn-blue"
						onClick={() =>
							this.setState({
								showForm: false,
								showConfirm: false,
								confirmed: false,
								delete: null
							})
						}
					>
						No
					</Button>
				</div>
			</div>
		);
	}

	render() {
		const { showForm, showConfirm } = this.state;

		return (
			<div>
				<div className="uploader-container">
					{showConfirm && this.renderConfirm()}

					{showForm && !showConfirm && this.renderForm()}

					{!showForm && !showConfirm && this.renderAttachments()}

					{!showForm &&
						!showConfirm && (
							<Row _gap-16 _no-grow _no-align buttons>
								<Button
									className="btn-square space-between btn-blue"
									onClick={this.openForm}
								>
									<FaPlus />
									<span>Add Attachment</span>
								</Button>
								<span>(optional)</span>
							</Row>
						)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	attachments: state.attachment.all,
	currentUser: state.auth.currentUser
});

const mapDispatchToProps = {
	addErrors: errors => dispatch => dispatch(setErrors(errors)),
	deleteErrors: inputName => dispatch =>
		dispatch(clearErrorsForInput(inputName)),
	createAttachment,
	updateAttachment,
	deleteAttachments
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AttachmentUploader);



// WEBPACK FOOTER //
// ./src/common/attachment/AttachmentUploader.js